import { createSelector } from 'reselect'

import {
  getApiCredentials, getApiMembers,
} from '../api/selectors'
import {
  getCurrentAccountId,
  getCurrentCredentialId
} from 'reduxes/slices/current/selectors'

export const getUsersHandles = createSelector([getApiCredentials], (credentials) => {
  return Object.values(credentials).map((credential) => credential.email)
})

export const getCurrentCredentialHandle = createSelector(
  [getApiCredentials, getCurrentCredentialId],
  (credentials, currentCredentialId) => {
    return credentials[currentCredentialId]?.email
  }
)
